export enum SortUsersDirection {
    ASC = 'asc',
    DESC = 'desc',
}
